import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CircleManageAdvancedRoute extends DiscourseRoute {
  showFooter = true;

  titleToken() {
    return i18n("discourse_circles.circle.manage.advanced.title_token");
  }

  model() {
    return this.modelFor("circle");
  }
}
